import React from 'react';

import { HeaderButtonsContainer } from './styledComponents';

export const FullScreenModalHeaderButtons = (props) => (
  <HeaderButtonsContainer>{props.children}</HeaderButtonsContainer>
);

export default FullScreenModalHeaderButtons;
